const areUnresolvedFeatureFlags = (flagsToCheck, featureFlags) =>
  flagsToCheck.some((flag) => featureFlags[flag] === undefined || featureFlags[flag] === null);

export default areUnresolvedFeatureFlags;
